import React from 'react'
import { FormInputSelectAndNavigate } from '../../../../../../../ui/organisms'

export default {
  title: 'Can you tell us what type of federal/state project this is?',
  next: 'projectInfo.projectRole',
  component: (props) => <FormInputSelectAndNavigate options={[
    'Public School',
    'Government Building',
    'Road/Bridge',
    'Public Transportation',
    'Library',
    'Public works',
    'State Park',
    'Native Land',
    'Hospitals, Community Centers, and Quasi-Public Places',
  ]} {...props}/>
}